"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteSystemFileMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.deleteSystemFileMutation = (0, graphql_tag_1.default) `
  mutation DeleteSystemFile($systemFileIds: [ID!]!) {
    deleteSystemFile(systemFileIds: $systemFileIds) {
      errorMessage
      deletionSuccessful
    }
  }
`;
//# sourceMappingURL=delete-system-file.js.map